// extracted by mini-css-extract-plugin
export default {"components-container":"Messages_components-container__IP982","mobile":"Messages_mobile__5Y+jX","web":"Messages_web__PYZvR"};